import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Fix ResizeObserver loop error (harmless browser warning from Radix UI/shadcn)
// This patches ResizeObserver to debounce callbacks and prevent the loop error
if (typeof window !== 'undefined') {
  const debounce = (callback, delay = 0) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => callback.apply(this, args), delay);
    };
  };

  // Patch ResizeObserver to prevent loop errors
  const OriginalResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
    constructor(callback) {
      super(debounce(callback, 20));
    }
  };

  // Also suppress any errors that still slip through
  const resizeObserverErr = (e) => {
    if (e.message === 'ResizeObserver loop completed with undelivered notifications.' ||
        e.message?.includes('ResizeObserver loop')) {
      e.stopImmediatePropagation();
      e.stopPropagation();
      e.preventDefault();
    }
  };
  
  window.addEventListener('error', resizeObserverErr);
  
  // Suppress via window.onerror as backup
  const originalOnError = window.onerror;
  window.onerror = (msg, url, line, col, error) => {
    if (msg.includes('ResizeObserver loop')) {
      return true;
    }
    if (originalOnError) {
      return originalOnError(msg, url, line, col, error);
    }
    return false;
  };
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
